import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { handlingApi } from "units/handlingApi";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      const token = Cookies.get("adminToken");

      if (!token) {
        navigate("/admin/login");
        return;
      }

      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}admin/dashboard-users`;
        const res = await handlingApi({ url, method: "GET", data: {}, token });
        if (res.statusCode === 200) {
          setUsers(res.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    };
    fetchUsers();
  }, [navigate]);

  // Helper function to return a styled badge based on the user's status
  const getStatusBadge = (status) => {
    let badgeClass = "";
    switch (status.toLowerCase()) {
      case "active":
        badgeClass = "bg-success";
        break;
      case "deleted":
        badgeClass = "bg-danger";
        break;
      default:
        badgeClass = "bg-secondary";
    }
    return (
      <span className={`badge ${badgeClass}`}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">
        <FontAwesomeIcon icon={faUser} /> Users
      </h3>
      <div className="shadow">
        <div className="card-body">
          {loading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="thead-light">
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Status</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, idx) => (
                    <tr key={idx}>
                      <td>{user.fName}</td>
                      <td>{user.lName}</td>
                      <td>{user.email}</td>
                      <td>{getStatusBadge(user.status)}</td>
                      {/* <td>
                        <Link
                          style={{ textDecoration: "none" }}
                          className="btn btn-primary fs-5"
                          to={`../user-detail/${user._id}`}
                        >
                          View
                        </Link>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
